<template>
    <b-container style="font-size:1.4rem;">
        
        
        <div id="printme">
        <img style="width:140px;float:left;margin-top:40px;" src="@/assets/images/logo.jpg">
        <b-row>
            <b-col>
                <h5 style="margin-top:40px;font-size:1.4rem;" align="center"><b>{{form.BoardName}}</b></h5>
                <P style="margin-bottom:100px;" align="center">{{form.BoardAddress}}</P>
            </b-col>
        </b-row>
        <hr style=" background-color: black;color: black;border: solid 1px;">
        <div style="box-sizing:border-box; border:2px solid black;">
        
        <b-row class="ml-1">
            <b-col sm="10">Receipt.No :{{form.AlltomentPreFixMarathi}}{{form.AllotmentYear}}/{{form.AllotmentNo}}</b-col>
            <b-col sm="2">Date :{{form.PaymentDate}}</b-col>
        </b-row>
        
        <h6 class="mt-4" align="center" style="font-size:1.2rem;"><b><u>REGISTRATION RECEIPT (SECURITY GUARD)</u></b></h6>
        <b-row style="text-align:center;padding:20px;">
            <b-col><b>Registration No.:-{{form.AlltomentPreFixMarathi}}{{form.AllotmentYear}}/{{form.AllotmentNo}}</b></b-col>
    
        </b-row>
        <b-row class="ml-1" style="padding-top:20px;">
            <b-col>Received with thanks from<b> {{form.FullName}}</b> a sum of Rs.100/ (Rupee one Hundred Only), through online payment, on account of Registration Fee.</b-col>
        </b-row>
        <div align="right" style="padding-top:80px;">
                <p style="margin-right:10%;"><b>Sd/-</b></p>
                <p style="width:23%;text-align:center;"><b>{{form.BoardName}}</b></p>
        </div>
        </div>
        <div class="my-2" style="box-sizing:border-box; border:2px solid black;">
        <h6 class="my-3" align="center" style="font-size:1.2rem;"><b><u>REGISTRATION DETAILS</u></b></h6>
            <b-row>
                <b-col sm="9">
                    <b-row class="my-2 ml-1">
                        <b-col sm="3">Application No.:</b-col>
                        <b-col sm="4">{{form.ApplicationNo}}</b-col>
                        <b-col sm="3">Application Date:</b-col>
                        <b-col sm="2">{{form.ApplicationDate}}</b-col>
                    </b-row>
                    <b-row class="ml-1">
                        <b-col sm="3"><b>Reg.No:</b></b-col>
                        <b-col sm="4"><b>{{form.AlltomentPreFixMarathi}}{{form.AllotmentYear}}/{{form.AllotmentNo}}</b></b-col>
                        <b-col sm="3">Date of Registration:</b-col>
                        <b-col sm="2">{{form.PaymentDate}}</b-col>
                    </b-row>
                    <b-row class="my-2 ml-1">
                        <b-col sm="3">Name:</b-col>
                        <b-col sm="5"><b>{{form.FullName}}</b></b-col>
                    </b-row>
                    <b-row class="ml-1">
                        <b-col sm="3">Category:</b-col>
                        <b-col sm="4"><b>{{form.Category}}</b></b-col>
                    </b-row>
                    <b-row class="my-2 ml-1">
                        <b-col sm="3">Type:</b-col>
                        <b-col sm="4"><b>{{form.RegType}}</b></b-col>
                        <b-col sm="5"><b>{{form.CompanyName}}</b></b-col>
                    </b-row>
                    <b-row class="my-2 ml-1">
                        <b-col sm="3">Date of Birth:</b-col>
                        <b-col sm="4">{{form.DOB}}</b-col>
                    </b-row>
                    <b-row class="ml-1">
                        <b-col sm="3">Date of Retirement:</b-col>
                        <b-col sm="4">{{form.RetirementDate}}</b-col>
                    </b-row>
                </b-col>
                <b-col sm="3">
                       <img style="width:160px" :src="getImgUrl(form.PhotoPath)"><br/>
                       <img style="width:160px;height:80px;" :src="getImgUrl(form.SignaturePath)">
                       <p>Specimen Signature</p>
                </b-col>
            </b-row>
                <br/>
            <b-row class="ml-1">
                <b-col sm="6"><b><u>Local Address</u></b>:</b-col>
                <b-col sm="6"><b><u>Native Address</u></b>:</b-col>
            </b-row>
            <b-row class="my-2 ml-1">
                <b-col sm="6">{{form.CorrespondanceAddress}}</b-col>
                <b-col sm="6">{{form.PermanentAddress}}</b-col>
            </b-row>
                <br/>
            <b-row class="ml-1">
                <b-col sm="2">Location:</b-col>
                <b-col sm="4"><b>{{form.Branch}}</b></b-col>
                <b-col sm="2">State:</b-col>
                <b-col sm="4"><b>Maharashtra</b></b-col>
            </b-row>
            <br/>
            <b-row class="ml-1">
                <b-col sm="6"><b><u>Nomination1</u></b>:</b-col>
                <b-col sm="6"><b><u>Nomination2</u></b>:</b-col>
            </b-row>
            <b-row class="my-2 ml-1">
                <b-col sm="6">{{form.Nominee1}}</b-col>
                <b-col sm="6">{{form.Nominee2}}</b-col>
            </b-row>
            <b-row class="ml-1">
                <b-col sm="6">{{form.Relation1}}</b-col>
                <b-col sm="6">{{form.Relation2}}</b-col>
            </b-row><br/>
            <b-row class="mb-2 ml-1">
                <b-col sm="2">Branch:</b-col>
                <b-col sm="4"><b>{{form.Branch}}</b></b-col>
                <b-col>
                    <qr-code 
                        :text=qrtext
                        size="100"
                        error-level="H">
                    </qr-code>
                </b-col>
            </b-row>
        </div>
            
        <p class="ml-1">*This is Computer generated receipt, does not require signature</p>
            
    </div>
           
        
        <b-row>
      <b-col>
   
          <b-button class="float-right mt-2" variant="info" @click="print">Print</b-button>
      </b-col>
    </b-row>
    </b-container>
</template>

<script>
import apis from "@/apis";
import vueHtmlToPaper from "vue-html-to-paper";
export default {
  props: ["appid"],
  data() {
    return {
      form: {
        ApplicationID: "",
        ApplicationNo: "",
        UserID: "",
        FullName: "",
        Category: "",
        RegType: "",
        DOB: "",
        RetirementDate: "",
        Nominee1: "",
        Relation1: "",
        Nominee2: "",
        Relation2: "",
        CorrespondanceAddress: "",
        PermanentAddress: "",
        Branch: "",
        CompanyName: "",
        UserBFormID: "",
        AllotmentNo: "",
        BoardID: "",
        AllotmentPrefix: "",
        AlltomentPreFixMarathi: "",
        AllotmentYear: "",
        IsFeesPaid: "",
        EventTitle: "",
        BoardName: "",
        BoardAddress: ""
      },
      isLoading: false,
      qrtext:"",
      alertText: "",
      showDismissibleAlert: false,
      variant: "success"
    };
  },

  methods: {
    print() {
      this.$htmlToPaper("printme");
    },
    getImgUrl(pic) {
      let userinfo = this.$store.getters.loggedUser;
      let userId = userinfo.UserId;
      if (pic) {
        if (pic.split(".").pop() == "pdf") {
          return require("@/assets/Pdf.jpg");
        }
        return (
          "https://s3.ap-south-1.amazonaws.com/sgbimages/" +
          userId +
          "/" +
          pic
        );
      }
    }
  },
  mounted() {

    let promise = apis.ReadBFormDetails(this.appid);

    promise
      .then(response => {
        //console.log(response);
        if (response.status == 200) {
          this.form = response.body[0];
          this.qrtext = "https://sgbregistration.in/#/summarybform/" + this.form.UserBFormID;
          this.isLoading = false;
        } else {
          this.alertText = response.body;

          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
      })
      .catch(err => {
        this.alertText = err.body;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });
  }
};
</script>

<style scoped>
  
</style>



// WEBPACK FOOTER //
// src/components/RegistrationDetails/Bform.vue